import { SiteIdOverrideConfigList } from "stores/wizard/config";
import {
  siteId1,
  siteId3,
  siteId4,
  siteId4_fr_CA,
  siteId4_en_CA,
  siteId6,
  siteId6_en_GB,
  siteId8,
  siteId9,
  siteId11,
  siteId11_nl_NL,
  siteId11_en_GB,
  siteId14,
  siteId15,
  siteId16,
  siteId17,
  siteId18,
  siteId6_de_DE,
  siteId20,
  siteId27,
  siteId28,
  siteId70201,
  siteId80001,
  siteId61,
  siteId62,
  siteId63,
  siteId64,
  siteId65,
  siteId66,
  siteId67,
  siteId68,
  siteId69,
  siteId70,
  siteId71,
  siteId72,
  siteId72_de_CH,
  siteId72_fr_CH,
  siteId72_en_GB,
  siteId73,
  siteId10122006,
  siteId10122006_de_DE,
  siteId10122006_en_GB,
} from "stores/wizard/config/overrideConfigBySiteId/siteIds";

export const overrideConfigBySiteIdList: SiteIdOverrideConfigList = {
  1: {
    default: siteId1,
  },
  3: {
    default: siteId3,
  },
  4: {
    default: siteId4,
    fr_CA: siteId4_fr_CA,
    en_CA: siteId4_en_CA,
  },
  6: {
    default: siteId6,
    de_DE: siteId6_de_DE,
    en_GB: siteId6_en_GB,
  },
  8: {
    default: siteId8,
  },
  9: {
    default: siteId9,
  },
  11: {
    default: siteId11,
    nl_NL: siteId11_nl_NL,
    en_GB: siteId11_en_GB,
  },
  14: {
    default: siteId14,
  },
  15: {
    default: siteId15,
  },
  16: {
    default: siteId16,
  },
  17: {
    default: siteId17,
  },
  18: {
    default: siteId18,
  },
  20: {
    default: siteId20,
  },
  27: {
    default: siteId27,
  },
  28: {
    default: siteId28,
  },
  61: {
    default: siteId61,
  },
  62: {
    default: siteId62,
  },
  63: {
    default: siteId63,
  },
  64: {
    default: siteId64,
  },
  65: {
    default: siteId65,
  },
  66: {
    default: siteId66,
  },
  67: {
    default: siteId67,
  },
  68: {
    default: siteId68,
  },
  69: {
    default: siteId69,
  },
  70: {
    default: siteId70,
  },
  71: {
    default: siteId71,
  },
  72: {
    default: siteId72,
    de_CH: siteId72_de_CH,
    fr_CH: siteId72_fr_CH,
    en_GB: siteId72_en_GB,
  },
  73: {
    default: siteId73,
  },
  70201: {
    default: siteId70201,
  },
  80001: {
    default: siteId80001,
  },
  10122006: {
    default: siteId10122006,
    de_DE: siteId10122006_de_DE,
    en_GB: siteId10122006_en_GB,
  },
};
